import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useSelector } from 'react-redux';
import { makeGetBasketCCPopupState } from '../../redux/basket/selectors/BasketSelector';
import { useProductListerContext } from './context/ProductListerContext';
import { Filters } from './filters/Filters';
/**
 * Convert FilterDTO (from API) to FilterObject (for Filter component)
 */
const mapFilterDTOToFilterObject = (filterDTO, isBrandPage) => {
    // Filter out brand filter if it's a brand page
    if (isBrandPage && filterDTO.filterOn === 'brand') {
        return null;
    }
    return {
        filterOn: filterDTO.filterOn || '',
        name: filterDTO.name || '',
        type: filterDTO.type || '',
        values: (filterDTO.values || []).map((value) => ({
            name: value.name || '',
            filterKey: value.filterKey || '',
            itemCount: value.itemCount,
            active: value.active || false,
            normalizedName: value.normalizedName,
        })),
        rangeMin: filterDTO.rangeMin,
        rangeMax: filterDTO.rangeMax,
        boundaryMin: filterDTO.rangeMin, // API doesn't provide boundary, use range as boundary
        boundaryMax: filterDTO.rangeMax,
        itemsToShow: filterDTO.itemsToShow,
        visibleSearchBox: filterDTO.visibleSearchBox,
        filterPrefix: filterDTO.filterPrefix,
        filterSuffix: filterDTO.filterSuffix,
        displayHint: filterDTO.displayHint,
        filterContentType: filterDTO.filterContentType,
    };
};
/**
 * Convert FredhopperGlossaryItemObject array to Record format
 */
const convertGlossaryToRecord = (glossary) => {
    const record = {};
    glossary.forEach(item => {
        item.triggers.forEach(trigger => {
            record[trigger] = {
                title: item.title,
                description: item.description,
            };
        });
    });
    return record;
};
export const ProductListerFilters = () => {
    var _a;
    const { pageInfo: { isBrandPage }, } = useAemConfig();
    const { filterState, query: { data }, fredhopperGlossary, urlFilters, updateFilter, removeAllFilters, } = useProductListerContext();
    const { collapsed } = useSelector(makeGetBasketCCPopupState());
    // Convert filters from FilterDTO[] to FilterObject[]
    const filters = filterState.availableFilters
        .map(filter => mapFilterDTOToFilterObject(filter, isBrandPage))
        .filter((filter) => filter !== null);
    // Convert glossary to Record format
    const glossaryRecord = convertGlossaryToRecord(fredhopperGlossary);
    // Handler for filter changes - dispatches to context
    const onFilterItemChange = (toggledFilter) => {
        updateFilter(toggledFilter);
    };
    return (_jsx(Filters, { filters: filters, itemCount: (_a = data === null || data === void 0 ? void 0 : data.itemCount) !== null && _a !== void 0 ? _a : 0, fredhopperGlossary: glossaryRecord, removeAllFilters: removeAllFilters, onFilterItemChange: onFilterItemChange, urlFilters: urlFilters, ccPopupCollapsed: collapsed }));
};
